import React from "react";
import classes from "./playersCard.module.css";
import { getImageUrl } from "../../../utils/imageUrl";

const PlayersCard = ({player}) => {
    return (
        <div className={classes.Container}>
            <div className={classes.ImageContainer}>
                <img src={getImageUrl(player.image)} alt={player.name}/>
            </div>
            <div className={classes.Info}>
                <h3>{player.name}</h3>
                <div className={classes.Location}>
                    <h4>{player.location}</h4>
                </div>
            </div>
        </div>
    )
}

export default PlayersCard;